<template>
  <div>
    <!-- {{ value }} -->
    <!-- {{ mifields }}  -->
    <!-- {{ item.tags }} -->
    <b-card class="mt-2 mb-0 smallinputs" header-tag="header" footer-tag="footer"
      :border-variant="value.groupby == 'deployment' ? 'info' : 'primary'">
      <b-card-body class="mt-2 py-0 px-0 ">
        <b-tabs class="gridtabs" v-model="tabindex">

          <b-tab active :class="value.groupby == 'deployment' ? 'deployment' : null">
            <template #title>
              <i class="fa fa-handshake-o text-primary mr-2"></i><span class="strong">{{ tabgroup
              }}</span>
            </template>

            <p class="pb-0 pt-3 mb-2 px-0 vertical-top">
              <b-row>
                <b-col>
                  <div class="mt-0 mb-1 text-center">
                    <table class="w-100pct">
                      <tr class="header-dark mb-1">
                        <td role="columnheader" scope="col" aria-colindex="1"
                          class="table-b-table-default text-center w-25px">
                          <input style="height: 15px; margin-top: 2px" type="checkbox" :checked="true"
                            :disabled="true" />
                        </td>
                        <!-- colspan="2"  -->
                        <td class="text-center w-35px">Group</td>
                        <!-- <td class="" style="width:25%">SL A/C</td>
                        <td class="" style="width:25%">Event</td> -->

                        <td class="" style="width:50%"><span v-if="mifields.length <= 0">Your
                            Ref / PO</span></td>
                        <td style="width:50%" @click="cliplines()">TransactionId <i @click="cliplines()"
                            :id="'lines-copy_' + value.id" class="fa fa-clipboard hover-primary" title="Copy"></i>
                        </td>
                        <b-tooltip :target="'lines-copy_' + value.id" placement="top">Copy
                          selected lines to the clipboard</b-tooltip>
                        <td></td>
                      </tr>
                      <tr>
                        <td class="w-30px pt-3px">
                          <b-input-group class="m-auto w-15px">
                            <input class="mt-5px" id="travellerCheck" style="height: 13px;" type="checkbox"
                              :checked="true" :value="true" :disabled="true" />
                          </b-input-group>
                        </td>
                        <td class="w-30px pt-5px"> <span class="small text-primary">{{ 0 + 1
                            }}.</span></td>
                        <!-- <td class="w-30px pt-5px"> <i
                                                        class="fa fa-handshake-o text-primary mr-2"></i>
                                                </td> -->
                        <!-- <td class="pt-3px">
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                                v-model="value.slac" :clearable="true" :multiple="false" :async="true"
                                :load-options="treeselect_loadSLAC" :show-count="true" :flatten-search-results="true"
                                :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                                <div slot="value-label" slot-scope="{ node }">
                                  {{ node.raw.id }}
                                </div>
                              </treeselect>
                            </b-input-group>
                          </b-form-group>
                        </td> -->
                        <!-- <td class="pt-3px">
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                                v-model="value.eventcode" :clearable="true" :multiple="false" :async="true"
                                :load-options="treeselect_loadEvent" :show-count="true" :flatten-search-results="true"
                                :disable-branch-nodes="true" :matchKeys="['id']" search-nested @select="treeselect">
                                <div slot="value-label" slot-scope="{ node }">
                                  {{ node.raw.id }}
                                </div>
                              </treeselect>
                            </b-input-group>
                          </b-form-group>
                        </td> -->

                        <td class="pt-3px">
                          <b-form-group class="mb-3px" v-if="mifields.length <= 0">
                            <b-input-group>
                              <b-form-input size="sm" v-model="value.yourref" placeholder="P/O" :formatter="onlyascii"
                                trim></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="value.yourref = ''">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <td class="w-400px pt-3px">{{ value.referenceno }}</td>
                        <td></td>
                      </tr>

                    </table>
                  </div>

                  <!-- {{ mifields }} -->

                  <div class="my-0">

                    <b-row align-v="start" class="" no-gutters v-if="mifields.length > 0">
                      <b-col cols="auto" class="text-right" style="width:56px">
                        <!-- <i class="fa fa-list text-primary"
                                                    style="margin-top:24px; margin-right:8px;"> </i> -->
                      </b-col>
                      <!-- <b-col v-if="mifields.length == 0"> There are no fields to display</b-col> -->
                      <b-col class="px-2">
                        <b-row>
                          <b-col cols="12" sm="6" md="4" xl="3" v-for="(mifield, index) in mifields" :key="index">
                            <!-- <b-form-group :label="label(mifield)" label-cols="12" label-size="sm">-->
                            <b-form-group :label="$helpers.requiredlabel(requirement, mifield.label)" :class="$helpers
                              .requiredlabel(requirement, mifield.label)
                              .slice(0, 1) == '*'
                              ? 'text-danger'
                              : ''
                              " label-cols="12" label-size="sm">
                              <b-input-group>
                                <!-- :placeholder="placeholder(mifield)" :debounce="mifields.debounce" -->
                                <!-- v-model="mifields.args[mifield.key]"  -->
                                <b-form-input v-if="mifield.type == 'input'" type="text"
                                  :disabled="mifield.active == '0'" size="sm" trim v-model="mifield.value"
                                  :placeholder="mifield.label"></b-form-input>

                                <!-- v-if="mifield.clearable" @click="mifields.args[mifield.key] = null"-->
                                <b-input-group-append v-if="mifield.type == 'input'">
                                  <b-button size="sm" variant="outline-secondary" @click="mifield.value = ''">
                                    <i class="fa fa-remove"></i>
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>

                              <!-- && filter.options
                      :multiple="filter.multiple == true ? true : false" -->
                              <!-- v-model="mifield.args[mifield.key]" :placeholder="mifield.placeholder"-->
                              <treeselect v-if="mifield.type == 'listofvalues'" :show-count="true"
                                :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                search-nested :clearable="mifield.required == '0' ? true : false"
                                :options="mifield.options" v-model="mifield.value">
                              </treeselect>

                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>




                  </div>

                  <div class="mt-2 mb-1 text-center xs-padding">
                    <table class="w-100pct">
                      <tr class="header-dark ">
                        <td role="columnheader" scope="col" aria-colindex="1"
                          class="table-b-table-default text-center w-25px">

                          <input id="linesAll" style="height: 15px; margin-top: 2px" type="checkbox"
                            :checked="allLinesChecked" @change="linesAll"
                            :disabled="value.lines.length == 1 || value.lines.filter(o => o.sale != 'N/A').length == 1" />
                        </td>
                        <!-- colspan="2"  -->
                        <td class="text-center w-35px">Lines </td>
                        <td>SupType</td>
                        <!-- <td> Issued </td> -->
                        <td> DateTravel</td>
                        <td> Event </td>
                        <td> SL A/C </td>
                        <td> Agent </td>
                        <td> Details </td>
                        <td> Payee </td>
                        <!-- <td> Last4 </td> -->
                        <!-- <td> Locator </td> -->
                        <td> DeploymentId </td>
                        <td> BL A/C </td>
                        <td> Cost GBP </td>
                        <td> Margin</td>
                        <td> Markup GBP</td>
                        <td> Sale GBP </td>
                      </tr>
                      <tr>
                        <td></td>
                        <!-- colspan="2" -->
                        <td></td>
                        <!-- <td> </td> -->
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <!-- <td> </td> -->
                        <!-- <td> </td> -->
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>

                      </tr>

                      <tr v-for="(line, index) in value.lines" :key="index">
                        <td class="w-30px">
                          <b-input-group class="m-auto w-15px">
                            <input class="mt-5px" id="lineCheck" style="height: 12px;" type="checkbox" v-model="lines"
                              @click="toggleLine($event, index)" :checked="true" :value="line"
                              :disabled="value.lines.length == 1 || line.fare == 'N/A' || value.lines.filter(o => o.fare != 'N/A').length == 1" />

                          </b-input-group>
                        </td>
                        <td class="w-30px pt-3px">

                          <!-- @click="addLine" -->
                          <i :id="'lines-split_' + value.id" class="fa fa-share-alt text-success font-14px"></i>
                          <b-tooltip :target="'lines-split_' + value.id" placement="top">Click to
                            split the charge</b-tooltip>
                          <span class="small text-primary ml-2">{{ index + 1 }}.</span>
                        </td>

                        <td class="w-70px p-0">
                          <b-row>
                            <b-col>
                              <b-form-group class="mb-3px z-0">
                                <b-input-group>
                                  <button type="button" :id="'lines-type_' + line.referenceno"
                                    class="h-22px radius-0 pr-1 btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split box-shadow-none"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span class="sr-only">Toggle Dropdown</span>
                                  </button>
                                  <b-button class="h-22px w-45px text-center background-white"
                                    :id="'lines-faicon_' + line.referenceno" size="sm" variant="outline-secondary"
                                    @click="setType(index)" :disabled="false">
                                    <span class="border-right-light">{{suppliertype_options.find(o
                                      => o.id
                                      ==
                                      line.type).id
                                    }} </span>
                                    <i :class="line.type ? 'fa ' + suppliertype_options.find(o => o.id == line.type).faicon : 'fa fa-exclamation-triangle text-danger'"
                                      class="font-14px w-20px pl-1"></i>
                                  </b-button>
                                  <b-tooltip :target="'lines-faicon_' + line.referenceno" placement="top">
                                    {{suppliertype_options.find(o => o.id ==
                                      line.type).label
                                    }}</b-tooltip>
                                  <b-popover :target="'lines-type_' + line.referenceno" title="Select Supplier Type"
                                    triggers="focus" :placement="'lefttop'" custom-class="p-0">
                                    <p v-for="(faicon, aindex) in suppliertype_options" :key="aindex"
                                      class="text-left hover-pointer hover-highlight px-2 py-1 mb-0">
                                      <span @click="setType(index, faicon.id)">
                                        <i class="w-20px" :class="'fa ' + faicon.faicon"></i>{{
                                          faicon.label
                                        }}</span>
                                    </p>
                                  </b-popover>
                                </b-input-group>
                              </b-form-group>

                              <!-- <b-dropdown :id="'lines-faicon_' + line.referenceno"
                                                                          split split-variant="outline-secondary"
                                                                          variant="secondary"
                                                                          :text="line.type ? line.type : '*'" size="sm"
                                                                          class="h-22px dropdown-input" style="">
                                                                          <b-dropdown-item
                                                                              v-for="(faicon, aindex) in suppliertype_options"
                                                                              :key="aindex" href="#"
                                                                              :active="line.type == faicon.id ? true : false"
                                                                              @click="setType(index, faicon.id)"><i
                                                                                  :class="'fa ' + faicon.faicon"></i> {{
                                                                                      faicon.label
                                                                                  }}</b-dropdown-item>
                                                                      </b-dropdown> -->


                              <!-- 
                                                                  <b-input-group-prepend>
                                                                      <b-button class="h-22px w-30px"
                                                                          :id="'lines-faicon_' + line.referenceno"
                                                                          size="sm" variant="outline-secondary"
                                                                          @click="setType(index)" :disabled="false">
                                                                          <i :class="line.type ? 'fa ' + suppliertype_options.find(o => o.id == line.type).faicon : 'fa fa-exclamation-triangle text-danger'"
                                                                              class="font-14px padding-left:5px !important; margin-top:15px"></i>
                                                                      </b-button>
                                                                      {{ line.type }}
                                                                      <b-button class="h-22px w-30px">
                                                                      </b-button>
                                                                      <div>
                                                                          <i v-for="(faicon, aindex) in suppliertype_options"
                                                                              :key="aindex"
                                                                              @click="setType(index, faicon.id)"><i
                                                                                  :class="'fa ' + faicon.faicon"></i> {{
                                                                                      faicon.label
                                                                              }}></i>
                                                                      </div>
                                                                      <b-tooltip
                                                                          :target="'lines-faicon_' + line.referenceno"
                                                                          placement="top">
                                                                          {{suppliertype_options.find(o => o.id ==
                                                                              line.type).label
                                                                          }}</b-tooltip>

                                                                  </b-input-group-prepend> -->


                              <!-- </b-form-group> -->
                              <!-- <b-form-group>
                                                                  <b-input-group>
                                                                      <div class="btn-group h-22px">
                                                                          <button variant="outline-secondary"
                                                                              type="button btn-sm h-22px"
                                                                              class="btn h-22px w-30px border-secondary radius-0"
                                                                              style="line-height:0.5; padding:7px;"
                                                                              :id="'lines-faicon_' + line.referenceno"
                                                                              size="sm" @click="setType(index)"
                                                                              :disabled="false">
                                                                              <i :class="line.type ? 'fa ' + suppliertype_options.find(o => o.id == line.type).faicon : 'fa fa-exclamation-triangle text-danger'"
                                                                                  class="font-14px padding-left:5px !important; "
                                                                                  style="line-height:0;"></i></button>
                                                                          <b-tooltip
                                                                              :target="'lines-faicon_' + line.referenceno"
                                                                              placement="top">
                                                                              {{suppliertype_options.find(o => o.id ==
                                                                                  line.type).label
                                                                              }}</b-tooltip>
                                                                          <button type="button"
                                                                              class="btn btn-secondary btn-sm dropdown-toggle dropdown-toggle-split"
                                                                              data-toggle="dropdown" aria-haspopup="true"
                                                                              aria-expanded="false">
                                                                              <span class="sr-only">Toggle Dropdown</span>
                                                                          </button>
                                                                          <div class="dropdown-menu h-22px dropdown-input"
                                                                              :id="'lines-faicon_' + line.referenceno"
                                                                              split split-variant="outline-secondary"
                                                                              variant="secondary"
                                                                              :text="line.type ? line.type : '*'"
                                                                              size="sm">
                                                                              <a class="dropdown-item"
                                                                                  v-for="(faicon, aindex) in suppliertype_options"
                                                                                  :key="aindex" href="#"
                                                                                  :active="line.type == faicon.id ? true : false"
                                                                                  @click="setType(index, faicon.id)"><i
                                                                                      :class="'fa ' + faicon.faicon"></i>
                                                                                  {{
                                                                                      faicon.label
                                                                                  }}</a>
                                                                          </div>
                                                                      </div>
                                                                  </b-input-group>
                                                              </b-form-group>
                                                              <b-form-group class="mb-3px z-0 relative">
                                                                  <b-input-group>
                                                                      <b-input-group-prepend>
                                                                          <b-button class="h-22px w-30px"
                                                                              :id="'lines-faicon_' + line.referenceno"
                                                                              size="sm" variant="outline-secondary"
                                                                              @click="setType(index)" :disabled="false">
                                                                              <i :class="line.type ? 'fa ' + suppliertype_options.find(o => o.id == line.type).faicon : 'fa fa-exclamation-triangle text-danger'"
                                                                                  class="font-14px padding-left:5px !important; margin-top:15px"></i>
                                                                          </b-button>
                                                                          <b-tooltip
                                                                              :target="'lines-faicon_' + line.referenceno"
                                                                              placement="top">
                                                                              {{suppliertype_options.find(o => o.id ==
                                                                                  line.type).label
                                                                              }}</b-tooltip>

                                                                      </b-input-group-prepend>

                                                                      <b-dropdown :id="'lines-faicon_' + line.referenceno"
                                                                          split split-variant="outline-secondary"
                                                                          variant="secondary"
                                                                          :text="line.type ? line.type : '*'" size="sm"
                                                                          class="h-22px dropdown-input" style="">
                                                                          <b-dropdown-item
                                                                              v-for="(faicon, aindex) in suppliertype_options"
                                                                              :key="aindex" href="#"
                                                                              :active="line.type == faicon.id ? true : false"
                                                                              @click="setType(index, faicon.id)"><i
                                                                                  :class="'fa ' + faicon.faicon"></i> {{
                                                                                      faicon.label
                                                                                  }}</b-dropdown-item>
                                                                      </b-dropdown>
                                                                    </b-input-group>
                                                              </b-form-group> -->

                            </b-col>
                          </b-row>

                        </td>

                        <td class="w-110px text-left">
                          <b-form-group class="mb-3px h-22px">
                            <b-input-group>
                              <daterangepicker class="w-auto" size="sm" ref="date_at" v-model="line.start_at_pick"
                                :opens="'right'" :locale-data="locale_data" :ranges="false" :showDropdowns="true"
                                :single-date-picker="'true'" @update="pick_date($event, 'start_at', line)">
                              </daterangepicker>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="line.start_at_pick = {
                                  startDate: null,
                                  endDate: null,
                                }
                                  ">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <span v-if="line.eventcodewasSet === undefined ? (line.eventcodewasSet = line.eventcode !== null && line.eventcode !== undefined) : true" style="display:none;"></span>
                        <td class="w-160px">                      
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <treeselect class="h-21px" placeholder="Select event..."
                                searchPromptText="Type at least 4 chars..." v-model="line.eventcode" :clearable="true" :disabled="line.eventcodewasSet"
                                :multiple="false" :async="true" :load-options="treeselect_loadEvent" :show-count="true"
                                :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                search-nested @select="edited = true">
                                <div slot="value-label" slot-scope="{ node }">
                                  {{ node.raw.id }}
                                </div>
                              </treeselect>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <td class="w-120px">
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <treeselect class="h-21px" placeholder="Select slac..."
                                searchPromptText="Type at least 3 chars..." v-model="line.slac" :clearable="true"
                                :multiple="false" :async="true" :load-options="treeselect_loadSLAC" :show-count="true"
                                :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                search-nested @select="edited = true">
                                <div slot="value-label" slot-scope="{ node }">
                                  {{ node.raw.id }}
                                </div>
                              </treeselect>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <td class="w-70px">
                          <b-row>
                            <b-col>
                              <b-form-group class="mb-3px">
                                <b-input-group>
                                  <b-dropdown :id="'lines-agent_' + line.referenceno" split
                                    split-variant="outline-secondary" variant="secondary"
                                    :text="line.agent ? line.agent : '***'" size="sm"
                                    class="h-22px dropdown-input background-white z-0 agent-dropdown" right>
                                    <b-dropdown-item v-for="(agent, aindex) in options_agent" :key="aindex" href="#"
                                      :active="line.agent == agent.id ? true : false"
                                      @click="claimLine(index, agent.id)">{{
                                        agent.label
                                      }}</b-dropdown-item>
                                  </b-dropdown>
                                  <b-input-group-append>
                                    <b-button :id="'lines-owner_' + line.referenceno" size="sm"
                                      variant="outline-secondary" @click="claimLine(index)" :disabled="false">
                                      <i :class="line.claimed ? 'fa fa-user text-primary font-14px' : 'fa fa-user text-danger font-14px'"
                                        class="padding-left:5px !important; margin-top:15px "></i>
                                    </b-button>
                                    <b-tooltip v-if="line.claimed" :target="'lines-owner_' + line.referenceno"
                                      placement="top">Click
                                      to
                                      unclaim, agent {{ line.agent }}</b-tooltip>
                                    <b-tooltip v-if="!line.claimed" :target="'lines-owner_' + line.referenceno"
                                      placement="top">Click
                                      to claim as {{ user.initials }}</b-tooltip>
                                  </b-input-group-append>
                                  <b-tooltip :target="'lines-agent_' + line.referenceno" placement="top">{{
                                    line.agentname ? line.agentname : '*BLOCKED*'
                                  }}</b-tooltip>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </td>

                        <!-- class="min-w-360px" -->
                        <td class="w-18pct text-left">

                          <div @click="line.expanded = !line.expanded"
                            class="text-left form-control form-control-sm disabled" :style="'cursor: pointer;'">
                            <i :class="line.expanded ? 'fa fa-long-arrow-up' : 'fa fa-pencil'"
                              class="text-info mr-1"></i>

                            {{ line.details.slice(0, 32) + '...' }}

                          </div>

                          <div v-if="line.expanded" class="mt-2 text-left" style="width:180%;">

                            <b-row no-gutters>
                              <b-col cols="3" class="mt-3px">Travellers:<i class="fa fa-info-circle text-black"
                                  :id="line.id + '_passenger'"></i></b-col>
                              <b-tooltip :target="line.id + '_passenger'" triggers="hover" placement="bottom">Enter
                                travellers SURNAME/FIRST,NEXT</b-tooltip>
                              <b-col cols="9"> <b-form-group>
                                  <b-input-group>
                                    <b-form-input size="sm" v-model="line.passenger" placeholder="Travellers"
                                      :disabled="false" @change="updateline(line, index)"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" @click="line.passenger = ''"
                                        :disabled="false">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>

                                </b-form-group></b-col>
                            </b-row>
                            <b-row no-gutters>
                              <b-col cols="3" class="mt-3px">Route:<i class="fa fa-info-circle text-black"
                                  :id="line.id + '_route'"></i></b-col>
                              <b-tooltip :target="line.id + '_route'" triggers="hover" placement="bottom">Enter
                                IATA
                                codes LHR/MIA or name of hotel</b-tooltip>
                              <b-col cols="9"> <b-form-group>
                                  <b-input-group>
                                    <b-form-input size="sm" v-model="line.routing" placeholder="Route" :disabled="false"
                                      @change="updateline(line, index)">
                                    </b-form-input> <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" @click="line.routing = ''"
                                        :disabled="false">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>

                                </b-form-group></b-col>
                            </b-row>
                            <b-row no-gutters>
                              <b-col cols="3" class="mt-3px">Remark:<i class="fa fa-info-circle text-black"
                                  :id="line.id + 'remark'"></i></b-col>
                              <b-tooltip :target="line.id + 'remark'" triggers="hover" placement="bottom">Enter
                                remark
                                info about charge</b-tooltip>
                              <b-col cols="9"> <b-form-group>
                                  <b-input-group>
                                    <b-form-input size="sm" v-model="line.remark" placeholder="Remark" :disabled="false"
                                      @change="updateline(line, index)"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" @click="line.remark = ''"
                                        :disabled="false">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>

                                </b-form-group></b-col>

                            </b-row>

                            <b-row no-gutters>
                              <b-col cols="3" class="mt-3px">DateTravel:<i class="fa fa-info-circle text-black"
                                  :id="line.id + 'traveldate'"></i>
                              </b-col>
                              <b-tooltip :target="line.id + 'traveldate'" triggers="hover" placement="bottom">Travel
                                dates from - to
                              </b-tooltip>
                              <b-col cols="5">
                                <b-form-group :id="line.id + 'traveldate1'">
                                  <b-input-group>
                                    <daterangepicker class="w-auto sm" size="sm" ref="start_at"
                                      v-model="line.start_at_pick" :opens="'right'" :locale-data="{
                                        direction: 'ltr',
                                        format: 'dd/mm/yy HH:MM',
                                        daysOfWeek: [
                                          'Sun',
                                          'Mon',
                                          'Tue',
                                          'Wed',
                                          'Thu',
                                          'Fri',
                                          'Sat',
                                        ],
                                        monthNames: [
                                          'January',
                                          'February',
                                          'March',
                                          'April',
                                          'May',
                                          'June',
                                          'July',
                                          'August',
                                          'September',
                                          'October',
                                          'November',
                                          'December',
                                        ],
                                        firstDay: 1,
                                        applyLabel: 'OK',
                                        cancelLabel: 'Cancel',
                                      }" :ranges="false" :showDropdowns="true" :single-date-picker="'true'"
                                      :timePicker="true" :timePicker24Hour="true" :time-picker-increment="1"
                                      @update="pick_date($event, 'start_at', line)">
                                    </daterangepicker>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" @click="line.start_at_pick = {
                                        startDate: null,
                                        endDate: null,
                                      }
                                        ">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                              <b-tooltip :target="line.id + 'traveldate1'" triggers="hover" placement="bottom">Travel
                                date from
                              </b-tooltip>
                              <b-col class="pl-1" cols="4">
                                <b-form-group :id="line.id + 'traveldate2'">
                                  <b-input-group>
                                    <daterangepicker class="w-auto sm" size="sm" ref="end_at" v-model="line.end_at_pick"
                                      :opens="'right'" :locale-data="{
                                        direction: 'ltr',
                                        format: 'dd/mm/yy HH:MM',
                                        daysOfWeek: [
                                          'Sun',
                                          'Mon',
                                          'Tue',
                                          'Wed',
                                          'Thu',
                                          'Fri',
                                          'Sat',
                                        ],
                                        monthNames: [
                                          'January',
                                          'February',
                                          'March',
                                          'April',
                                          'May',
                                          'June',
                                          'July',
                                          'August',
                                          'September',
                                          'October',
                                          'November',
                                          'December',
                                        ],
                                        firstDay: 1,
                                        applyLabel: 'OK',
                                        cancelLabel: 'Cancel',
                                      }" :ranges="false" :showDropdowns="true" :single-date-picker="'true'"
                                      :timePicker="true" :timePicker24Hour="true" :time-picker-increment="1"
                                      @update="pick_date($event, 'end_at', line)">
                                    </daterangepicker>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" @click="line.end_at_pick = {
                                        startDate: null,
                                        endDate: null,
                                      }
                                        ">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                              <b-tooltip :target="line.id + 'traveldate2'" triggers="hover" placement="bottom">Travel
                                date to
                              </b-tooltip>

                            </b-row>

                            <b-row class="divider mt-1 mb-2" no-gutters></b-row>
                            <b-row no-gutters>
                              <b-col cols="3" class="mt-3px">Locator:<i class="fa fa-info-circle text-black"
                                  :id="line.id + 'locator'"></i></b-col>
                              <b-tooltip :target="line.id + 'locator'" triggers="hover" placement="bottom">Locator
                                reference of
                                booking
                              </b-tooltip>
                              <b-col cols="9"> <b-form-group>
                                  <b-input-group>
                                    <b-form-input size="sm" v-model="line.locator" placeholder="Locator"
                                      :disabled="true"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" @click="line.locator = ''"
                                        :disabled="true">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>

                                </b-form-group></b-col>
                            </b-row>


                            <b-row no-gutters>
                              <b-col cols="3" class="mt-3px">Payee:<i class="fa fa-info-circle text-black"
                                  :id="line.id + 'payee'"></i></b-col>
                              <b-tooltip :target="line.id + 'payee'" triggers="hover" placement="bottom">Narrative from
                                the
                                statement</b-tooltip>
                              <b-col cols="9"> <b-form-group>
                                  <b-input-group>
                                    <b-form-input size="sm" v-model="line.description" placeholder="Narrative"
                                      :disabled="true"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" @click="line.description = ''"
                                        :disabled="true">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>

                                </b-form-group></b-col>
                            </b-row>

                            <b-row no-gutters>
                              <b-col cols="3" class="mt-3px">Last4:<i class="fa fa-info-circle text-black"
                                  :id="line.id + 'last4'"></i></b-col>
                              <b-tooltip :target="line.id + 'last4'" triggers="hover" placement="bottom">Last4 digits of
                                card
                              </b-tooltip>
                              <b-col cols="9"> <b-form-group>
                                  <b-input-group>
                                    <b-form-input size="sm" v-model="line.last4" placeholder="Last4"
                                      :disabled="true"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" @click="line.last4 = ''"
                                        :disabled="true">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>

                                </b-form-group></b-col>
                            </b-row>

                            <b-row no-gutters>

                              <b-col cols="3" class="mt-3px">Tkt:/Ref:<i class="fa fa-info-circle text-black"
                                  :id="line.id + 'referenceno'"></i></b-col>
                              <b-tooltip :target="line.id + 'referenceno'" triggers="hover"
                                placement="bottom">Transaction ID
                              </b-tooltip>
                              <b-col cols="9"> <b-form-group>
                                  <b-input-group>
                                    <b-form-input size="sm" v-model="line.referenceno" placeholder="Tkt/Ref"
                                      :disabled="true"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" @click="line.referenceno = ''"
                                        :disabled="true">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>

                                </b-form-group></b-col>
                            </b-row>


                            <b-row no-gutters>

                              <b-col cols="3" class="mt-3px">Issued:<i class="fa fa-info-circle text-black"
                                  :id="line.id + 'issued_at'"></i></b-col>
                              <b-tooltip :target="line.id + 'issued_at'" triggers="hover" placement="bottom">Issued
                              </b-tooltip>
                              <b-col cols="9"> <b-form-group>
                                  <b-input-group>
                                    <b-form-input size="sm"
                                      :value="$moment(line.issued_at).utc(true).format('DD/MM/YY')"
                                      placeholder="Tkt/Ref" :disabled="true"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" @click="line.issued_at = ''"
                                        :disabled="true">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>

                                </b-form-group></b-col>
                            </b-row>
                            <!-- <b-row class="my-2">
                                                              <b-col cols="6"><b-button squared size="sm" class="xs py-0"
                                                                      :variant="'outline-primary'"
                                                                      :disabled="value.posted" @click="updateit(line)">
                                                                      Update It
                                                                  </b-button></b-col>

                                                              <b-col class="text-right">
                                                                  <b-button size="sm" class="xs py-0" squared
                                                                      variant="secondary"
                                                                      @click="line.expanded = !line.expanded">
                                                                      <i class="fa fa-chevron-left pr-1"></i>
                                                                      Back
                                                                  </b-button>
                                                              </b-col>
                                                          </b-row> -->
                            <b-row class="my-2">
                              <b-col cols="6">
                                <!-- <b-button squared size="sm" class="xs py-0"
                                                                      :variant="'outline-primary'"
                                                                      :disabled="value.posted" @click="updateit(line)">
                                                                      Update It
                                                                  </b-button> -->
                              </b-col>

                              <b-col class="text-left">
                                <b-button size="sm" class="xs py-0" squared variant="secondary"
                                  @click="line.expanded = !line.expanded">
                                  <i class="fa fa-arrow-up pr-1"></i>
                                  Close
                                </b-button>
                              </b-col>
                            </b-row>
                          </div>

                          <!-- <b-form-group>
                                              <b-form-textarea
                                                  :style="'min-height:22px !important; font-size:12px; color:#549c60 !important; padding:0; padding-left:1px '"
                                                  v-model="line.description"></b-form-textarea>
                                          </b-form-group> -->
                        </td>
                        <td :id="'description_' + line.referenceno">
                          <div class="text-center form-control form-control-sm disabled">
                            <!-- {{ line.description }} -->
                            {{ line.description.slice(0, 10) + '...' }}
                          </div>
                        </td>

                        <!-- <b-tooltip :target="'referenceno_' + line.referenceno"
                                                      placement="left">{{
                                                          line.description
                                                      }}</b-tooltip> -->

                        <!-- <td>
                            <div class="text-center form-control form-control-sm disabled">
                              {{ line.last4 }}</div>
                          </td> -->

                        <b-tooltip :target="'description_' + line.referenceno" placement="left">{{
                          line.description
                        }}</b-tooltip>
                        <!-- <td>
                            <div class="text-center form-control form-control-sm disabled">
                              {{ line.locator }}</div>
                          </td> -->
                        <td :id="'referenceno_' + line.referenceno">
                          <div class="text-center form-control form-control-sm disabled">
                            {{ line.token }}</div>
                        </td>
                        <td>
                          <div class="text-center form-control form-control-sm disabled">
                            {{ line.blac }}</div>
                        </td>

                        <td class="w-100px" :id="'cost_' + line.referenceno">
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" v-model="line.cost" placeholder="Cost" class="text-right text-red"
                                :formatter="nocomma" :disabled="true"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                          <b-tooltip :target="'cost_' + line.referenceno" placement="left">
                            <u>Currency</u><br />
                            <span v-if="line.cost">{{ line.costcurrency }} : {{ line.cost
                            }}</span>
                            <span v-if="line.costlocalcurrency && line.costlocal != line.cost"><br />{{
                              line.costlocalcurrency }} :
                              {{ line.costlocal }}</span>
                          </b-tooltip>
                        </td>
                        <td>
                          <div class="text-right form-control form-control-sm disabled">
                            <span class="strong"
                              :style="parseFloat(line.cost) <= 0 || parseFloat(line.margin) <= 0 ? 'color:#dc3545' : 'color:#3cb450'">{{
                                line.margin }} %</span>
                          </div>
                        </td>

                        <td :id="'markup_' + line.referenceno" class="w-5pct">
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" v-model="line.markup" placeholder="Markup" class="text-right"
                                :formatter="nocomma" :disabled="true"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <b-tooltip :target="'markup_' + line.referenceno" placement="left">
                          Change the Sale value to calculate new markup. Or click X in Sale
                          box to zero this charge
                          and hide it from the invoice.
                        </b-tooltip>
                        <td class="w-120px">
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-input-group-append style="margin-right:-1px" v-if="lines.length > 1 ? true : false">
                                <b-button :id="'bullseye_' + line.referenceno + '_' + index" size="sm"
                                  variant="outline-secondary"
                                  @click="lines.forEach((el) => { el.sale = '0'; }); line.sale = JSON.parse(value.data).sale">
                                  <i class="fa fa-long-arrow-up text-primary"></i>
                                </b-button>
                              </b-input-group-append>
                              <b-form-input size="sm" v-model="line.sale" placeholder="Sale" class="text-right"
                                :formatter="onlynumbers"
                                :disabled="lines.filter(o => o.id == line.id).length == 0"></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="line.sale = '0'"
                                  :disabled="lines.filter(o => o.id == line.id).length == 0">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>

                            </b-input-group>
                          </b-form-group>
                        </td>

                        <b-tooltip v-if="lines.length > 1 ? true : false"
                          :target="'bullseye_' + line.referenceno + '_' + index" placement="left">
                          Click to push the total sale up to this line and zero all other
                          lines.
                        </b-tooltip>
                      </tr>

                      <!-- <tr>
                        <td :id="'lines-add_' + value.id" class="w-30px">
                          <i class="fa fa-plus-square text-info font-14px" @click="addLine"></i>
                          <b-tooltip :target="'lines-add_' + value.id" placement="top">Click
                            add new line and split the charge on this invoice</b-tooltip>
                        </td> -->
                      <!-- <td colspan="12">
                          <b-form-group v-if="showsheetlines" label-for="sheetlines" label-cols="12">
                            <b-form-textarea id="sheetlines" v-model="sheetlines"
                              placeholder="Paste data lines from spreadsheet" rows="8" max-rows="8"
                              class="smalltextarea" :disabled="false"></b-form-textarea>
                          </b-form-group>
                        </td> -->
                      <!-- </tr> -->
                      <tr>
                        <td class="pl-1 text-left pt-1" colspan="10">
                          <b-row class="mt-2" no-gutters>
                            <b-col cols="auto" class="text-left">
                              <b-button size="sm" class="xs line-height-0" :variant="'outline-primary'" @click="saveit"
                                :disabled="value.posted">
                                Save It
                              </b-button>
                            </b-col>
                            <b-col class="text-left ml-2 mt-0">
                              <div v-if="busy">
                                <i class="fa fa-spinner fa-spin text-primary"></i>
                              </div>
                              <div v-else>
                                <span v-html="message_saveit"></span>
                              </div>
                            </b-col>
                          </b-row>

                        </td>

                        <!-- <td colspan="7" class="pr-1 text-right"></td> -->
                        <td><span class="h6 strong">Total</span></td>
                        <td>
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" v-model="value.cost" placeholder="Cost"
                                class="text-right strong text-red" :formatter="nocomma" :disabled="true"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <td>
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" v-model="value.margin" placeholder="Margin"
                                class="text-right strong"
                                :class="parseFloat(value.margin) > 0 ? 'text-primary' : 'text-red'" :formatter="nocomma"
                                :disabled="true"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <td>
                          <b-form-group :id="'markup_original_' + value.id" class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" v-model="value.markup" placeholder="Markup"
                                class="text-right strong" :formatter="nocomma" :disabled="true"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                          <!-- <b-tooltip :target="'markup_original_' + value.id" placement="left">
                                                            Original Markup : {{ JSON.parse(value.data).markup }}
                                                        </b-tooltip> -->
                        </td>
                        <td>
                          <b-form-group :id="'sale_original_' + value.id" class="mb-3px">
                            <b-input-group>
                              <b-input-group-append v-if="lines.length > 1">
                                <b-button size="sm" variant="outline-secondary" :disabled="true">
                                  <i class="fa fa-long-arrow-up text-primary"></i>
                                </b-button>
                              </b-input-group-append>
                              <b-form-input size="sm" v-model="value.sale" placeholder="Sale" class="text-right strong"
                                :disabled="true"></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="value.sale = '0.00'"
                                  :disabled="true">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                            <b-tooltip :target="'sale_original_' + value.id" placement="left">
                              Original Sale : {{ JSON.parse(value.data).sale }}
                            </b-tooltip>
                          </b-form-group>
                        </td>

                      </tr>
                      <tr v-if="1 == 0">
                        <td colspan="12" class="pr-1 text-right"><span class="h6 strong">Admin
                            Fee</span></td>
                        <td>
                          <b-form-group>
                            <b-input-group>
                              <b-form-input size="sm" v-model="value.adminfee" placeholder="Admin Fee"
                                class="text-right strong" :formatter="nocomma"></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="value.adminfee = '0.00'">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </td>
                      </tr>
                    </table>
                  </div>

                </b-col>
              </b-row>
            </p>
          </b-tab>

          <b-tab
            v-if="(value.slac && value.eventcode) && (value.slac != 'ATOLSALE' && value.slac != 'CONFINV') && !value.posted"
            @click="renderit">
            <template #title>
              <i class="fa fa-wpforms text-primary mr-1"></i>Draft
            </template>
            <p class="py-0 px-0">
            <div v-if="parseFloat(value.cost) != 0 && parseFloat(value.sale) <= 0">
              <b-alert :show="true" variant="danger">
                <b-row align-v="center" no-gutters class="font-13px">
                  <b-col cols="auto mr-3">
                    <i class="fa fa-exclamation-circle fa-2x"></i>
                  </b-col>
                  <b-col>
                    There is a cost on this transaction of <strong>GBP </strong>
                    <strong><span class="text-2x">{{ value.cost }}</span></strong>
                    , please be sure there is no client sale to invoice?
                  </b-col>
                </b-row>
              </b-alert>
            </div>
            <div v-if="parseFloat(value.cost) == 0 && parseFloat(value.sale) == 0">
              <b-alert :show="true" variant="success">
                <b-row align-v="center" no-gutters class="font-13px">
                  <b-col cols="auto mr-3">
                    <i class="fa fa-exclamation-circle fa-2x"></i>
                  </b-col>
                  <b-col>
                    The charges on this transaction match off to 0 GBP it can be recorded as a No
                    Sale Reqiured. Please be sure there is no client sale to invoice?
                  </b-col>
                </b-row>
              </b-alert>
            </div>
            <div class="etr" v-if="parseFloat(value.sale) > 0">
              <b-row>
                <b-col cols="12">
                  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
                    <r-invoice :showasdraft="true" :item="item" />
                    <!-- <b-alert v-if="item.message" show :variant="item.level"
                                                class="text-center mt-2 mb-1">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-info-circle fa-2x"></i></b-col>
                                                    <b-col> <span
                                                            v-html="item.message.split('\n').join('<br/>')"></span></b-col></b-row>
                                            </b-alert> -->
                  </b-overlay>
                  <b-card-footer class="mt-2 ml-1">
                    <b-row>
                      <b-col class="text-left">
                        <b-row class="mt-1">
                          <b-col>
                            <b-button v-if="permissionvalid('salesledger.save')" squared size="sm" class="ml-1"
                              variant="warning" @click="showledgers = !showledgers" :pressed="!showledgers">
                              Ledgers<i :class="showledgers ? 'fa fa-arrow-up ml-1' : 'fa fa-arrow-down ml-1'
                                "></i>
                            </b-button>
                          </b-col>
                          <b-col>
                            <div v-if="busy">
                              <i class="fa fa-spinner fa-spin text-primary"></i>
                              <span class="text-success ml-2">Preparing set of
                                invoice(s)</span>
                            </div>
                            <div v-else>
                              <span v-html="message"></span>
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col class="text-right">
                        <b-button-group class="z-0" v-if="items.length > 1">
                          <b-button squared size="sm" @click="render()" variant="outline-primary" class="mr-1 h-28px">
                            <i class="fa fa-refresh"></i>
                          </b-button>

                          <b-pagination hide-ellipsis v-model="page" :total-rows="items.length" :per-page="1"
                            align="right" size="sm"></b-pagination>
                        </b-button-group>


                      </b-col>

                    </b-row>

                  </b-card-footer>
                  <div v-if="showledgers" class="mx-4">
                    <b-row>
                      <b-card class="border-none w-100pct">
                        <b-card-title class="text-left">B/L Item Headers</b-card-title>
                        <d-table classdivtable="availtable datatable" refid="blitemheaders" :items="data.BL"
                          :showpages="false" :showtoolbar="false">
                        </d-table>
                      </b-card>
                    </b-row>
                    <b-row>
                      <b-card class="border-none w-100pct">
                        <b-card-title class="text-left">S/L Item Headers</b-card-title>
                        <d-table classdivtable="availtable datatable" refid="blitemheaders" :items="SL"
                          :showpages="false" :showtoolbar="false">
                        </d-table> </b-card></b-row>
                    <b-row>
                      <b-card class="border-none w-100pct">
                        <b-card-title class="text-left">l Item Lines</b-card-title>
                        <d-table classdivtable="availtable datatable" refid="blitemheaders" :items="data.SL[0].items"
                          :showpages="false" :showtoolbar="false">
                        </d-table> </b-card></b-row>
                  </div>
                </b-col>
              </b-row>
            </div>
            </p>
          </b-tab>


          <b-tab>
            <template #title>
              <div class="badgecontainer pr-1 mr-1">
                <i class="fa fa-comments-o text-primary mr-1"></i> Notes
                <b-badge id="notes" variant="danger" class="edit_tab" v-if="value.notes">
                  {{ value.notes ? '1' : '' }} </b-badge>
              </div>

            </template>
            <p>
              <b-row class="mt-2">
                <b-col cols="12">
                  <b-form-group label="Notes" label-for="notes" label-cols="12">
                    <b-input-group class="treeselect_all pr-2px">
                      <span style="padding-top: 0.3em; padding-left:32px" id="notes-tooltip">
                        <i class="fa fa-info-circle text-black"></i></span>
                      <b-tooltip target="notes-tooltip" triggers="hover" placement="bottom">Please
                        let us know below
                        the reason if you are delaying the invoicing e.g. waiting for PO,
                        waiting for
                        next statement etc.
                      </b-tooltip>

                    </b-input-group>
                    <b-form-textarea id="notes" v-model="value.notes" placeholder="Reason for not invoicing?" rows="10"
                      max-rows="10" class="smalltextarea courier"></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col cols="auto">
                  <b-button-group class="z-0">
                    <b-button size="sm" class="xs line-height-0" :variant="'outline-primary'" @click="saveit"
                      :disabled="value.posted">
                      Save It
                    </b-button>
                    <b-button size="sm" variant="outline-primary" class="xs line-height-0 ml-1" @click="timestamp">
                      <i class="fa fa-comment-o" style="margin:-1px;"></i>
                      Add Notes
                    </b-button>

                  </b-button-group>
                </b-col>
                <b-col class="text-left ml-0 mt-0">
                  <div v-if="busy">
                    <i class="fa fa-spinner fa-spin text-primary"></i>
                  </div>
                  <div v-else>
                    <span v-html="message_saveit"></span>
                  </div>
                </b-col>
              </b-row>
            </p>
          </b-tab>


          <b-tab>
            <template #title>
              <i class="fa fa-plus-square text-primary mr-1"></i> Additional
            </template>
            <p>

              <b-row no-gutters class="my-2">
                <b-col class="divider"></b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label-cols="12" label="Transaction ID" label-size="sm">
                    <treeselect id="referenceno" placeholder="Select referenceno..." :clearable="false"
                      v-model="referenceno" :options="referenceno_options" :disable-branch-nodes="true"
                      :show-count="true" />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group label="Original details" label-for="booking" label-cols="12">
                    <b-form-textarea id="booking" v-model="booking" placeholder="Booking" rows="30" max-rows="30"
                      class="smalltextarea courier" :disabled="true"></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
            </p>
          </b-tab>
        </b-tabs>

      </b-card-body>

      <b-row v-if="lines.filter(l => l.start_at == 'Invalid date').length > 0" class="px-0">
        <b-col>
          <b-alert :show="true" variant="danger">
            <b-row align-v="center" no-gutters class="font-13px"><b-col cols="auto mr-3">
                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
              <b-col>
                Please add a valid datetravel.</b-col></b-row>
          </b-alert></b-col>
      </b-row>

      <b-row v-if="!value.eventcode" class="px-0">
        <b-col>
          <b-alert :show="true" variant="danger">
            <b-row align-v="center" no-gutters class="font-13px"><b-col cols="auto mr-3">
                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
              <b-col>
                Please add a valid eventcode.</b-col></b-row>
          </b-alert></b-col>
      </b-row>

      <b-row v-if="!value.slac || value.slac == 'CONFINV' || value.slac == 'ATOLSALE'" class="px-0">
        <b-col>
          <b-alert :show="true" variant="danger">
            <b-row align-v="center" no-gutters class="font-13px"><b-col cols="auto mr-3">
                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
              <b-col>
                Please add a valid slac.</b-col></b-row>
          </b-alert></b-col>
      </b-row>

      <b-row v-if="parseFloat(value.sale) <= 0 && !drafted" class="px-0">
        <b-col>
          <b-alert :show="true" variant="danger">
            <b-row align-v="center" no-gutters class="font-13px"><b-col cols="auto mr-3">
                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
              <b-col>
                You must <i class="fa fa-wpforms text-primary mr-1"></i>Draft this Invoice before you
                can send it to accounts.</b-col></b-row>
          </b-alert></b-col>
      </b-row>

      <template #footer>

        <b-row class="mx-n4">
          <b-col cols="auto" class="text-left">

            <b-button class="" squared size="sm" v-if="postit_visible" :variant="postit_variant"
              :disabled="value.posted || posting || busy || !$store.state.invoicing || !drafted" @click="postit">
              <i :class="postit_icon"></i>
              {{ postit_label }}
            </b-button>

          </b-col>
          <!-- <b-col cols="auto" class="text-left" v-if="lines.length > 1 && postit_visible">
            <input id="perline" style="height: 15px; margin-top: 3px" type="checkbox" v-model="perline"
              :disabled="value.posted">
            <span class="ml-2" @click="perline = !perline">Invoice per line</span>
          </b-col> -->
          <b-col align-self="center" v-if="!value.posted && !busy && !draft"><span v-if="postit_visible"
              v-html="readymessage"></span>
            <span class="ml-2" v-html="message"> </span> </b-col>
          <b-col cols="auto">
            <b-row>
              <b-col cols="auto" align-self="center">
                <h5 :class="ZColour">
                  {{ ZTotal }}
                </h5>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mx-n4">
          <b-col cols="12">
            <b-alert v-if="item.message" show :variant="item.level" class="text-center mt-2 mb-1 font-normal">
              <b-row align-v="center" no-gutters class="font-13px"><b-col cols="auto mr-0">
                  <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                <b-col> <span class="alert-message"
                    v-html="item.message.split('\n').join('<br/>')"></span></b-col></b-row>
            </b-alert>
          </b-col>
        </b-row>
      </template>

    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "i-cinvoice",
  data() {
    return {
      tabindex: 0,
      message: "",
      message_saveit: "",
      busy: false,
      // true from the Invoice click until the post reply comes back, success
      // or error. After a successful post the parent sets value.posted, which
      // keeps the button disabled; the value watcher also resets it.
      posting: false,
      draft: false,
      drafted: false,
      perline: false,
      expanded: false,
      lines: [],
      referenceno: null,
      referenceno_options: [],
      suppliertype_options: [],
      booking: null,
      notes: null,
      creditno: null,
      page: 1,
      level: ["success"],
      ss: [],
      items: [],
      item: {
        ref: "",
      },
      data: null,
      SL: [],
      showledgers: false,
      prefix: "IV",
      options_prefix: [
        { id: "IV", label: "IV | Conferma " },
        { id: "CV", label: "CV | Credit" },
      ],
      level: ["success"],
      options_level: [
        { id: "success", label: "Success" },
        { id: "warning", label: "Warning" },
        { id: "danger", label: "Danger" },
      ],
      options_agent: [],
      showsheetlines: false,
      sheetlines: null,
    };
  },
  async mounted() {
    try {
      const response = await this.$apollo.query({
        query: gql`
          query suppliertypes {
            suppliertypes {
              id
              label
              faicon
            }
          }
        `,
      });
      this.suppliertype_options = response.data.suppliertypes.filter(
        (o) => o.faicon != ""
      );
    } catch (error) {
      console.log(error);
    }
    await this.load_agents()
  },
  props: {
    value: { type: Object, required: true },
    title: { type: String, default: "" },
  },
  computed: {
    tabgroup() {
      let result = "";
      if (this.value.slac) {
        result += this.value.slac + " ( " + this.value.slacname + " )";
      } else {
        result += "*BLOCKED*";
      }
      result += " | ";
      if (this.value.eventcode) {
        result += this.value.eventcode + " ( " + this.value.eventname + " )";
      } else {
        result += "*BLOCKED*";
      }
      return result;
    },
    readymessage() {
      return (
        "<span class='text-primary'>Ready to submit " +
        this.invoicecount +
        " document(s).</span>"
      );
    },
    invoicecount() {
      return this.perline ? this.value.lines.length : 1;
      if (this.value.passengers) {
        let yourrefs = [
          ...new Set(
            this.value.passengers.map((item) =>
              item.yourref ? item.yourref : null
            )
          ),
        ];
        count = yourrefs.length;
      }
      return count;
    },
    ZTotal() {
      let sale = 0.0;
      let cost = 0.0;
      let markup = 0.0;
      let margin = 0;
      let vat = 0;
      for (var k = 0; k < this.lines.length; k++) {
        cost += parseFloat(this.lines[k].cost);

        if (this.lines[k].sale == "") {
          this.lines[k].sale = "0";
        }

        if (this.lines[k].sale != "-") {
          sale += parseFloat(this.lines[k].sale);
        }
        vat += parseFloat(this.lines[k].vat);

        if (parseFloat(this.lines[k].sale) != 0 && this.lines[k].sale != "-") {
          this.lines[k].margin =
            1 - parseFloat(this.lines[k].cost) / parseFloat(this.lines[k].sale);
        } else {
          this.lines[k].margin = 0;
        }
        this.lines[k].margin = (this.lines[k].margin * 100).toFixed(2);

        if (this.lines[k].sale != "-") {
          this.lines[k].markup = (
            parseFloat(this.lines[k].sale) - parseFloat(this.lines[k].cost)
          ).toFixed(2);
        }
        markup += parseFloat(this.lines[k].markup);
      }

      this.value.cost = cost.toFixed(2);
      this.value.markup = markup.toFixed(2);
      this.value.sale = sale.toFixed(2);

      this.value.vat = vat.toFixed(2);
      this.value.total = (sale + vat).toFixed(2);
      if (sale != 0) {
        this.value.margin = (
          (1 - parseFloat(cost) / parseFloat(sale)) *
          100
        ).toFixed(2);
      } else {
        this.value.margin = (0).toFixed(2);
      }
      this.value.margin += " %";
      if (this.value.sale < 0) {
        this.drafted = false;
      }

      return (
        this.lines.length +
        " lines * ( " +
        cost.toFixed(2) +
        " + " +
        markup.toFixed(2) +
        " = " +
        (sale + vat).toFixed(2) +
        " ) = GBP " +
        (sale + vat).toFixed(2)
      );
    },
    ZColour() {
      let result = "text-primary";
      if (parseFloat(this.value.markup) <= 0) {
        result = "text-danger";
      }
      result += " strong mb-0";
      return result;
    },
    allLinesChecked() {
      const checked = this.lines.length;
      // // console.log("allAreChecked?", checked);
      return checked === this.value.lines.length;
    },
    postit_visible() {
      if (!this.value.eventcode) {
        return false;
      }
      if (!this.value.slac) {
        return false;
      }
      if (this.value.slac == "ATOLSALE") {
        return false;
      }
      if (this.value.slac == "CONFINV") {
        return false;
      }

      // if (!this.permissionvalid('bookingforms.admin')) { return false }
      return true;
    },
    postit_variant() {
      if (this.posting || this.busy) {
        return "warning";
      } else {
        if (!this.$store.state.invoicing) {
          return "danger";
        } else {
          if (parseFloat(this.value.sale) > 0) {
            return "primary";
          } else if (parseFloat(this.value.sale) < 0) {
            return "danger";
          } else {
            if (parseFloat(this.value.cost) == 0) {
              return "dark";
            } else {
              return "info";
            }
          }
        }
      }
    },
    postit_icon() {
      if (this.posting || this.busy) {
        return "fa fa-spinner fa-spin text-white mr-1";
      } else {
        if (!this.$store.state.invoicing) {
          return "fa fa-ban mr-1";
        } else {
          if (this.value.posted) {
            return "fa fa-stack-overflow mr-1";
          } else {
            if (
              parseFloat(this.value.sale) == 0 &&
              parseFloat(this.value.cost) == 0
            ) {
              return "fa fa-paper-plane mr-1";
            } else {
              return "fa fa-paper-plane mr-1";
            }
          }
        }
      }
    },
    postit_label() {
      if (this.posting) {
        return "Posting...";
      }
      if (this.busy) {
        if (this.value.posted) {
          return "Posting to Ledgers";
        }
      } else {
        if (!this.$store.state.invoicing) {
          return "Invoicing Off";
        } else {
          if (this.value.posted) {
            this.message_saveit =
              "<span class='text-primary'>Saved it.  " +
              this.items
                .map((l) => l.ref)
                .sort()
                .join(",") +
              "</span>";
            return (
              "Invoiced on " +
              this.items
                .map((l) => l.ref)
                .sort()
                .join(",")
            );
          } else {
            if (parseFloat(this.value.sale) > 0) {
              return "Invoice It";
            } else if (parseFloat(this.value.sale) < 0) {
              return "Credit It";
            } else {
              return "No Sale Required";
              // if (parseFloat(this.value.cost) == 0) {
              //     return 'No Sale ?'
              // } else if (parseFloat(this.value.cost) > 0) {
              //     return 'No Charge ?'
              // } else {
              //     return 'No Credit ?'
              // }
            }
          }
        }
      }
    },
  },
  watch: {
    referenceno: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.load_bankingline(newVal);
      },
    },
    value: {
      immediate: true,
      async handler(newVal, oldVal) {
        this.item = {};

        this.creditno = null;
        this.lines = newVal.lines;

        for (var k = 0; k < this.lines.length; k++) {
          let pick = null;
          if (
            this.lines[k].start_at &&
            this.lines[k].start_at != "Invalid date"
          ) {
            pick = this.lines[k].start_at;
          }
          this.lines[k].start_at_pick = {
            startDate: pick,
            endDate: pick,
          };
        }

        for (var k = 0; k < this.lines.length; k++) {
          let pick = null;
          if (this.lines[k].end_at && this.lines[k].end_at != "Invalid date") {
            pick = this.lines[k].end_at;
          }
          this.lines[k].end_at_pick = {
            startDate: pick,
            endDate: pick,
          };
        }

        this.item.tags = newVal.tags ? newVal.tags : "{}";
        this.item.slac = newVal.slac;
        this.item.yourref = newVal.yourref;
        this.item.stype = this.lines[0].type;
        //this.item.issued_at = this.lines[0].issued_at
        await this.load_mifields();

        this.tabindex = 0;
        this.perline = false;
        let refs = newVal.referenceno.split(",");
        this.referenceno_options = [];
        for (var i = 0; i < refs.length; i++) {
          this.referenceno_options.push({ id: refs[i], label: refs[i] });
        }
        if (this.referenceno_options.length > 0) {
          this.referenceno = this.referenceno_options[0].id;
        }
        this.message_saveit = "";
        this.posting = false;

        this.drafted = false;
        if (parseFloat(this.value.sale) > 0) {
          this.drafted = true;
        }
      },
    },
    page: {
      async handler(newVal, oldVal) {
        if (newVal) {
          if (newVal <= this.ss.length) {
            this.item = this.ss[newVal - 1];

            if (this.item.data) {
              this.data = JSON.parse(this.item.data);
              this.SL = [];
              this.SL.push({ ...this.data.SL[0] });
              delete this.SL[0].items;
            }
          }
        }
      },
    },
  },
  methods: {
    icontype(value) {
      let result = "fa fa-arrows-h";
      switch (value) {
        case "AIR":
          result = "fa fa-plane text-primary";
          break;
        case "CAR":
          result = "fa fa-car text-info";
          break;
        case "HTL":
          result = "fa fa-bed text-orange";
          break;
        case "EMD":
          result = "fa fa-user-plus text-purple";
          break;
        case "RAIL":
          result = "fa fa-train text-danger";
          break;
        case "XFR":
          result = "fa fa-map-marker text-dark";
          break;
        case "SEA":
          result = "fa fa-ship text-danger";
          break;
      }
      return result;
    },
    onlyascii(value) {
      // A SPECIFIC REPLACE
      value = value.split("b").join("");
      value = value
        .normalize("NFD")
        .replace(/([\u0300-\u036f]|[^\x20-\x7E])/g, "");
      return value;
    },
    cliplines() {
      try {
        window.navigator.clipboard.writeText(this.value.referenceno);
      } catch (error) {
        console.log(error);
      }
    },
    linesAll(evt) {
      const list = this.allLinesChecked
        ? []
        : this.value.lines.slice(0, this.value.lines.length);
      this.lines = list;
    },
    toggleLine(evt, index) {

      const savedIndex = this.savedIndex;
      this.savedIndex = index;

      // If this is the first pass or no shift key was
      // pressed, just bail.
      if (savedIndex === null || !evt.shiftKey) return;

      // Shift-clicked the same message :-/
      if (index === savedIndex) return;

      // Get the subset of the message list between the
      // two indicies.
      // console.time("toggle range");
      const subset = this.items.slice(
        Math.min(index, savedIndex),
        Math.max(index, savedIndex) + 1
      );
      // Determine the operation based on the checked state
      // of the clicked checkbox.
      const toggleFn = evt.currentTarget.checked
        ? addCheckedSubset
        : removeCheckedSubset;

      this.lines = toggleFn(this.lines, subset);
      // console.timeEnd("toggle range");
    },
    addLine() {
      let _copy = { ...this.lines[this.lines.length - 1] }
      _copy.cost = (0).toFixed(2)
      _copy.sale = (0).toFixed(2)
      _copy.total = (0).toFixed(2)
      this.lines.push(_copy)
    },
    async renderit() {

      this.draft = true;

      let quote = { ...this.value };
      quote.lines = this.lines; //.filter(o => o.cost != 'N/A')
      quote.tags = this.item.tags;
      let variables = {
        data: JSON.stringify(quote),
        prefix: this.prefix,
        creditno: this.creditno,
        perline: this.perline,
        apply: false,
      };

      try {
        const response = await this.$apollo.query({
          query: gql`
            query ihold_draftinvoice(
              $data: String
              $prefix: String
              $creditno: String
              $perline: Boolean
              $apply: Boolean
            ) {
              ihold_draftinvoice(
                data: $data
                prefix: $prefix
                creditno: $creditno
                perline: $perline
                apply: $apply
              ) {
                id
                ref
                refcredit
                to
                address
                dateref
                slac
                agent
                yourref
                booker
                eventname
                vatregion
                vatreclaim
                saletotal
                terms
                credit
                tags
                data
                mifields {
                  label
                  value
                }
                document {
                  fields {
                    key
                    label
                    class
                  }
                  items
                }
                message
                level
              }
            }
          `,
          variables,
          fetchPolicy: "no-cache",
        });

        this.items = response.data.ihold_draftinvoice;
        let sset = this.items;
        this.ss = sset;

        this.item = { ref: "" };
        if (this.ss) {
          if (this.ss.length > 0) {
            this.item = this.ss[0];
            this.SL = [];

            if (this.item.data) {
              this.data = JSON.parse(this.item.data);
              this.SL.push({ ...this.data.SL[0] });
              delete this.SL[0].items;
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
      this.draft = false;
      this.drafted = true;
    },
    async timestamp() {
      if (!this.value.notes) {
        this.value.notes = "";
      }
      this.value.notes +=
        this.$moment().format("DD/MM/YY HH:mm") +
        " " +
        this.user.initials +
        "\n";
    },
    async claimLine(line, agent) {

      let row = {
        id: this.lines[line].id,
      }

      if (!agent && this.lines[line].agent) {
        this.lines[line].claimed = false
        this.lines[line].agent = ""
        row.agent = ""
      } else {
        this.lines[line].claimed = true
        if (agent) {
          this.lines[line].agent = agent
          row.agent = agent
        } else {
          this.lines[line].agent = this.user.initials
          row.agent = this.user.initials
        }
      }
      let variables = {
        rows: [row]
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
                    mutation inventorylines_save(
                        $rows: [InventoryLine_input]               
                    ) {
                        inventorylines_save(rows: $rows) {
                            id
                        }
                    }
                    `,
          variables,
        });

      } catch (error) {

      }

    },
    pick_date(evt, prop, line) {
      let find = this.$moment(line[prop], "YYYY-MM-DD HH:mm").format(
        "DD/MM/YY HH:mm"
      );
      // let find = this.$moment.unix(line[prop]* 0.001).utc(false).format("DD/MM/YY HH:mm")
      let replace = this.$moment(evt.startDate).format("DD/MM/YY HH:mm");
      line.remark = line.remark.split(find).join(replace);
      line[prop] = this.$moment(evt.startDate).format("YYYY-MM-DD HH:mm");
    },
    async setType(index, type) {
      this.lines[index].type = type;
    },
    async saveit() {
      console.log("saveit");

      let grouping = "";

      if (grouping) {
        for (var i = 0; i < rows.length; i++) {
          rows[i].grouping = grouping;
        }
      }

      let rows = [];
      for (var i = 0; i < this.lines.length; i++) {
        let row = {
          id: this.lines[i].id,
        };
        if (this.value.notes) {
          row.notes = this.value.notes;
        }
        if (this.value.yourref || this.value.yourref == "") {
          row.yourref = this.value.yourref
        }
        if (this.lines[i].eventcode || this.lines[i].eventcode == "") {
          row.eventcode = this.lines[i].eventcode
        }
        if (this.lines[i].slac || this.lines[i].slac == "") {
          row.slac = this.lines[i].slac
        }
        if (this.lines[i].sale) {
          // THIS IS THE CHECK IF CHANGED
          if (this.lines[i].sale != JSON.parse(this.value.data).lines[i].sale) {
            row.sale = this.lines[i].sale;
            grouping = "manual";
          }
        }
        if (this.lines[i].agent || this.lines[i].agent == "") {
          row.agent = this.lines[i].agent;
          if (this.lines[i].agent) {
            this.lines[i].claimed = true;
          }
        }
        if (this.lines[i].passenger || this.lines[i].passenger == "") {
          row.surname = this.lines[i].passenger.toUpperCase();
        }
        if (this.lines[i].routing || this.lines[i].routing == "") {
          row.routing = this.lines[i].routing.toUpperCase();
        }
        if (this.lines[i].remark || this.lines[i].remark == "") {
          row.remark = this.lines[i].remark.toUpperCase();
        }
        if (this.lines[i].start_at || this.lines[i].start_at == "") {
          row.start_at = this.lines[i].start_at;
        }
        if (this.lines[i].end_at || this.lines[i].end_at == "") {
          row.end_at = this.lines[i].end_at;
        }
        rows.push(row);
      }

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation inventorylines_save($rows: [InventoryLine_input]) {
              inventorylines_save(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });

        this.message_saveit = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message_saveit =
          "<span class='text-danger'>" + error.message + "</span>";
      }

      let tags = JSON.parse(this.item.tags);
      if (this.mifields.length > 0) {
        for (var k = 0; k < this.mifields.length; k++) {
          tags[this.mifields[k].key] = this.mifields[k].value;
        }
      }
      let requirements = await this.mifields_requirement();
      if (requirements.length > 0) {
        this.message_saveit =
          "<span class='text-danger'>" +
          requirements.slice(0, -1) +
          " required field(s). </span>";
        this.busy = false;
        return;
      } else {
        this.message_saveit = "";
      }

      rows = [];
      for (var i = 0; i < this.lines.length; i++) {
        let row = {
          id: this.lines[i].id,
        };

        if (tags) {
          this.item.tags = JSON.stringify(tags);
          row.tags = this.item.tags;
        }
        rows.push(row);
      }


      variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation inventorylines_save($rows: [InventoryLine_input]) {
              inventorylines_save(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });

        this.message_saveit = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message_saveit =
          "<span class='text-danger'>" + error.message + "</span>";
      }
      return;
    },
    async postit() {
      console.log("postit");

      // Helpdesk 10604: a re-click after the first post completed, or with
      // changed MI fields, sent a second ihold_draftinvoice and produced two
      // invoices. Refuse re-entry and keep the button disabled while posting.
      if (this.posting) {
        console.log("postit ignored: already posting", this.value.id);
        return;
      }
      this.posting = true;

      this.saveit();

      let requirements = await this.mifields_requirement();
      if (requirements.length > 0) {
        console.log("postit blocked: MI required fields", requirements);
        this.busy = false;
        this.posting = false;
        return;
      }

      this.busy = true;

      let quote = this.value;
      quote.lines = this.lines; // .segments.filter(o => o.fare != 'N/A')
      quote.tags = this.item.tags;

      let variables = {
        data: JSON.stringify(quote),
        prefix: this.prefix,
        creditno: this.creditno,
        perline: this.perline,
        apply: true,
      };

      try {
        const response = await this.$apollo.query({
          query: gql`
            query ihold_draftinvoice(
              $data: String
              $prefix: String
              $creditno: String
              $perline: Boolean
              $apply: Boolean
            ) {
              ihold_draftinvoice(
                data: $data
                prefix: $prefix
                creditno: $creditno
                perline: $perline
                apply: $apply
              ) {
                id
                ref
                refcredit
                to
                address
                dateref
                slac
                agent
                yourref
                booker
                eventname
                vatregion
                vatreclaim
                saletotal
                terms
                credit
                tags
                data
                mifields {
                  label
                  value
                }
                document {
                  fields {
                    key
                    label
                    class
                  }
                  items
                }
                message
                level
              }
            }
          `,
          variables,
          fetchPolicy: "no-cache",
        });

        this.items = response.data.ihold_draftinvoice;
        // the post is done; value.posted (set by the parent on the emit
        // below) keeps the button disabled from here on
        this.posting = false;
        let sset = this.items;
        this.ss = sset;

        this.item = { ref: "" };
        if (this.ss.length > 0) {
          this.item = this.ss[0];
          this.SL = [];

          if (this.item.data) {
            this.data = JSON.parse(this.item.data);
            this.SL.push({ ...this.data.SL[0] });
            delete this.SL[0].items;
          }
        }
      } catch (error) {
        console.log("postit failed", this.value.id, error);
        // the button re-enables and the error shows next to it and in the
        // tab; return before the emit so the parent does not mark the row
        // as posted
        // the message slots are rendered with v-html elsewhere in this component, so
        // escape the server text rather than concatenating it into markup
        let safe = String(error.message || "")
          .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
        let msg = "<span class='text-danger'>" + safe + "</span>";
        this.message = msg;
        this.message_saveit = msg;
        this.busy = false;
        this.posting = false;
        return;
      }
      this.$emit("postit");

      this.busy = false;
    },
    async updateline(line, index) {
      let variables = {
        line: this.cleanit(line),
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query ihold_draftdetails($line: Hhold_line_input) {
              ihold_draftdetails(line: $line) {
                id
                type
                issued_at
                last4
                token
                referenceno
                reference
                routing
                remark
                locator
                start_at
                details
                description
                passenger
                qty
                sale
                vat
                markup
                total
                cost
                blac
                slac
                costcurrency
                margin
                agent
                notes
                expanded
              }
            }
          `,
          variables,
          fetchPolicy: "no-cache",
        });

        let line = response.data.ihold_draftdetails;
        this.lines[index].details = line.details;
      } catch (error) {
        console.log(error);
      }

      return;
    },
    async updateit(line) {
      let row = {
        id: line.id,
        travellers: line.passenger,
        routing: line.routing,
        remark: line.remark,
        start_at: line.start_at,
      };

      let variables = {
        rows: [row],
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation inventorylines_save($rows: [InventoryLine_input]) {
              inventorylines_save(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });

        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async load_bankingline(id) {
      if (!id) {
        id = this.referenceno_options[0].id;
      }
      let variables = {
        reference: id,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query bankingslines($reference: String) {
              bankingslines(reference: $reference) {
                data
              }
            }
          `,
          variables,
        });

        this.booking = response.data.bankingslines[0].data;
      } catch (error) {
        console.log(error);
      }
    },
    async load_agents() {

      let variables = {
        status: "0",
        rolename: "user,admin",
        department: "F1,EVENTS",
        orderby: [["[firstname]", "asc"]]
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_users($status:String, $rolename:String, $department: String, $orderby: [[String]]) {
                setup_users(status: $status, rolename:$rolename, department: $department, orderby: $orderby) {
                    id: initials
                    label: labelagent
                }
            }
        `,
          variables,
        });

        this.options_agent = response.data.setup_users

      } catch (error) {
        console.log(error);
      }
    }
  },
};
</script>

<style></style>